import {Component, Input, OnInit} from '@angular/core';
import {VekoAccount} from 'src/app/model/account';
import {Constant} from 'src/app/shared/constants/constant.class';
import {LayoutService} from '../../../service/core/layout.service';
import {FAKE_MENUS_ADMIN} from './mock_menu';
import {AppConfigService} from '../../../../app-config.service';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss'],
})
export class AsideComponent implements OnInit {
  @Input() layoutType: any;
  disableAsideSelfDisplay: boolean;
  headerLogo: string;
  brandSkin: string;
  ulCSSClasses: string;
  location: Location;
  asideMenuHTMLAttributes: any = {};
  asideMenuCSSClasses: string;
  asideMenuDropdown;
  brandClasses: string;
  asideMenuScroll = 1;
  asideSelfMinimizeToggle = false;
  menus: any[];
  appName: any;

  constructor(private layout: LayoutService,
              private configService: AppConfigService,
  ) {
    const appName = this.configService.getConfig().api.appName;
    if (appName) {
      this.appName = appName;
    } else {
      this.appName = 'Invivo LAB';
    }
  }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem(Constant.USER_INFO));
    // @ts-ignore
    if (user.userType === 0) {
      this.menus = user.menus;
      this.menus[2]?.children.push(
        /*{
          name: "Nhận mẫu nhanh",
          path: "/admin/specimen/specimen-immediate",
          children: Array(0),
        },*/
        /*{
          name: "Thống kê số lượng chỉ định",
          path: "/admin/report/ordertype-report",
          children: Array(0),
        }*/
      );
      /*this.menus[2].children.push({
        name: 'Cấu hình định mức thời gian',
        path: '/admin/danhmuc/appointment-time',
        children: Array(0),
      });*/
    } else if (user.userType === 2) {
      // Tài khoản bệnh nhân
      this.menus = user.menus;
      // this.menus =  [{
      //   name: 'Dành cho bệnh nhân',
      //   path: '',
      //   children: [
      //     {
      //       name: 'Kết quả',
      //       path: '/admin/order/list',
      //       children: []
      //     },
      //   ]
      // }];
    } else if (user.userType === 1) {
      this.menus = [];
    }

    console.log(this.menus);

    this.disableAsideSelfDisplay =
      this.layout.getProp('aside.self.display') === false;
    this.brandSkin = this.layout.getProp('brand.self.theme');
    this.headerLogo = this.getLogo();
    this.ulCSSClasses = this.layout.getProp('aside_menu_nav');
    this.asideMenuCSSClasses = this.layout.getStringCSSClasses('aside_menu');
    this.asideMenuHTMLAttributes = this.layout.getHTMLAttributes('aside_menu');
    this.asideMenuDropdown = this.layout.getProp('aside.menu.dropdown')
      ? '1'
      : '0';
    this.brandClasses = this.layout.getProp('brand');
    this.asideSelfMinimizeToggle = this.layout.getProp(
      'aside.self.minimize.toggle'
    );
    this.asideMenuScroll = this.layout.getProp('aside.menu.scroll') ? 1 : 0;
    this.asideMenuCSSClasses = `${this.asideMenuCSSClasses} ${
      this.asideMenuScroll === 1 ? 'scroll my-4 ps ps--active-y' : ''
    }`;
    console.log(this.menus);
  }

  private getLogo() {
    /*if (this.layoutType === 'ADMIN') {
      return './assets/image/logo_dark.png';
    } else {
      return './assets/image/logo_dark.png';
    }*/
    return './assets/image/invivo.png';
  }
}
